import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { putScriptNoFlujo } from '../../routing/routes';
import LoadingGIF from '../assets/loading.gif';

const dataTypes = ['texto', 'imagen', 'audio', 'video', 'documento'];

const ModifyScript = ({ scriptsNoFlujo, archivos, functionesChatbot, refreshData, setNotification }) => {
  const { id } = useParams();
  const [script, setScript] = useState(null);

  console.log('Todos los scripts', scriptsNoFlujo);

  useEffect(() => {
    setScript(scriptsNoFlujo.find((script) => script._id === id));
  }, [scriptsNoFlujo, id]);

  if (script) {
    return (
      <ScriptNF
        script={script}
        archivos={archivos}
        refreshData={refreshData}
        setNotification={setNotification}
        functionesChatbot={functionesChatbot}
      />
    );
  } else {
    return (
      <div style={{ margin: '100px 0px' }}>
        <h3 style={{ textAlign: 'center' }}>CARGANDO...</h3>
        <div style={{ textAlign: 'center' }}>
          <span>
            <img style={{ height: '200px', width: '200px' }} src={LoadingGIF} alt={'Cargando'} />
          </span>
        </div>
      </div>
    );
  }
};

export default ModifyScript;

const ScriptNF = ({ script, archivos, refreshData, setNotification, functionesChatbot }) => {
  const [nuevoScript, setNuevoScript] = useState(script);
  const [flagFunctions, setFlagFunctions] = useState(false);

  //   useEffect(() => {
  //     console.log('Scirpt nuevo', nuevoScript);

  //     if (nuevoScript.ejecutaFuncion && nuevoScript.ejecutaFuncion.length > 0) {
  //       const temp = { ...nuevoScript };
  //       let flag = false;
  //       temp.ejecutaFuncion = temp.ejecutaFuncion.map((funcion) => {
  //         if (functionesChatbot.includes(funcion.nombreFuncion)) {
  //           return funcion;
  //         } else {
  //           funcion.nombreFuncion = '';
  //           flag = true;
  //           return funcion;
  //         }
  //       });
  //       setFlagFunctions(flag);
  //       setNuevoScript(temp);
  //     }
  //   }, [functionesChatbot, nuevoScript]);

  return (
    <div style={{ width: '80%', margin: '40px auto' }}>
      <div align="right">
        <div className="taby">{script.tipoScript}</div>
      </div>
      <div className="form-container">
        <Scripts nuevoScript={nuevoScript} setNuevoScript={setNuevoScript} archivos={archivos} />
        <Buttons nuevoScript={nuevoScript} setNuevoScript={setNuevoScript} />
        <Functions nuevoScript={nuevoScript} setNuevoScript={setNuevoScript} functionesChatbot={functionesChatbot} />
        {/* <SaveDelete nuevoScript={nuevoScript} refreshData={refreshData} setNotification={setNotification} flagFunctions={flagFunctions} /> */}
        <SaveDelete nuevoScript={nuevoScript} refreshData={refreshData} setNotification={setNotification} />
      </div>
    </div>
  );
};

function toggle_variable(parametro) {
  if (parametro[0] === '&') {
    parametro = parametro.slice(1, -1);
  } else {
    parametro = '&' + parametro + '*';
  }
  return parametro;
}

//#region Seccion de los scripts

function Scripts({ nuevoScript, setNuevoScript, archivos }) {
  return (
    <div>
      {nuevoScript.scripts &&
        nuevoScript.scripts.map((script, index) => {
          // script => {tipo:XXXX, valor:XXXX, externo:XXXX}
          switch (script.tipo) {
            case 'imagen':
              return (
                <MultimediaScript
                  key={index}
                  index={index}
                  nuevoScript={nuevoScript}
                  setNuevoScript={setNuevoScript}
                  archivos={archivos.imagenes}
                />
              );
            case 'audio':
              return (
                <MultimediaScript
                  key={index}
                  index={index}
                  nuevoScript={nuevoScript}
                  setNuevoScript={setNuevoScript}
                  archivos={archivos.audios}
                />
              );
            case 'video':
              return (
                <MultimediaScript
                  key={index}
                  index={index}
                  nuevoScript={nuevoScript}
                  setNuevoScript={setNuevoScript}
                  archivos={archivos.videos}
                />
              );
            case 'documento':
              return (
                <MultimediaScript
                  key={index}
                  index={index}
                  nuevoScript={nuevoScript}
                  setNuevoScript={setNuevoScript}
                  archivos={archivos.documentos}
                />
              );
            default:
              return <TextScript key={index} index={index} nuevoScript={nuevoScript} setNuevoScript={setNuevoScript} />;
          }
        })}
      <button
        className="add-button rectangle"
        onClick={() =>
          setNuevoScript({
            ...nuevoScript,
            scripts: [...nuevoScript.scripts, { tipo: 'texto', valor: '', externo: false }],
          })
        }
      >
        +
      </button>
    </div>
  );
}

function TextScript({ index, nuevoScript, setNuevoScript }) {
  return (
    <div>
      <hr />
      <b>Script {index + 1}</b>
      <br />
      <div>
        <textarea
          onChange={(e) => {
            const newScripts = nuevoScript.scripts;
            newScripts[index] = { tipo: 'texto', valor: e.target.value, externo: false };
            setNuevoScript({
              ...nuevoScript,
              scripts: newScripts,
            });
          }}
          value={nuevoScript.scripts[index].valor}
          style={{ width: '60%', height: 64, resize: 'none' }}
        ></textarea>

        <button
          onClick={() =>
            setNuevoScript({
              ...nuevoScript,
              scripts: [...nuevoScript.scripts.slice(0, index), ...nuevoScript.scripts.slice(index + 1)],
            })
          }
          className="remove-button"
          style={{ position: 'absolute' }}
        >
          x
        </button>
      </div>

      <div style={{ marginTop: '10px' }}>
        <span style={{ marginRight: '5px' }}>Tipo de script</span>
        <select
          onChange={(e) => {
            const newScripts = nuevoScript.scripts;
            newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
            setNuevoScript({
              ...nuevoScript,
              scripts: newScripts,
            });
          }}
          value={nuevoScript.scripts[index].tipo}
        >
          {dataTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

function MultimediaScript({ index, nuevoScript, setNuevoScript, archivos }) {
  return (
    <div>
      <hr />
      <b>Script {index + 1}</b>
      <br />
      <div style={{ marginTop: '10px' }}>
        {!nuevoScript.scripts[index].externo ? (
          <select
            onChange={(e) => {
              const newScripts = nuevoScript.scripts;
              newScripts[index].valor = e.target.value;
              setNuevoScript({
                ...nuevoScript,
                scripts: newScripts,
              });
            }}
            value={nuevoScript.scripts[index].valor}
          >
            <option key="" value="">
              Selecciona un archivo
            </option>
            {archivos.map((file) => (
              <option key={file} value={file}>
                {file}
              </option>
            ))}
          </select>
        ) : (
          <span>
            <span style={{ marginRight: '15px' }}>URL del archivo:</span>
            <input
              style={{ width: '500px' }}
              value={nuevoScript.scripts[index].valor}
              onChange={(e) => {
                const newScripts = nuevoScript.scripts;
                newScripts[index].valor = e.target.value;
                setNuevoScript({
                  ...nuevoScript,
                  scripts: newScripts,
                });
              }}
            />
          </span>
        )}

        <button
          onClick={() =>
            setNuevoScript({
              ...nuevoScript,
              scripts: [...nuevoScript.scripts.slice(0, index), ...nuevoScript.scripts.slice(index + 1)],
            })
          }
          className="remove-button"
          style={{ position: 'absolute' }}
        >
          x
        </button>
      </div>
      <div style={{ marginTop: '10px' }}>
        <span>¿El archivo es externo?</span>
        <input
          type="checkbox"
          checked={nuevoScript.scripts[index].externo}
          onChange={() => {
            const newScripts = nuevoScript.scripts;
            newScripts[index].externo = !newScripts[index].externo;
            newScripts[index].valor = '';
            setNuevoScript({
              ...nuevoScript,
              scripts: newScripts,
            });
          }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <span style={{ marginRight: '5px' }}>Tipo de script</span>
        <select
          onChange={(e) => {
            const newScripts = nuevoScript.scripts;
            newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
            setNuevoScript({
              ...nuevoScript,
              scripts: newScripts,
            });
          }}
          value={nuevoScript.scripts[index].tipo}
        >
          {dataTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

//#endregion

//#region Seccion para la creacion de botones

function Buttons({ nuevoScript, setNuevoScript }) {
  return (
    <div>
      <br />
      <hr />
      <div>
        <b>Botones</b>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
        {nuevoScript.botones &&
          nuevoScript.botones.map((boton, index) => {
            return (
              <div key={index} style={{ margin: 10 }}>
                <small>Opcion {index + 1}</small>
                <button
                  onClick={() =>
                    setNuevoScript({
                      ...nuevoScript,
                      botones: [...nuevoScript.botones.slice(0, index), ...nuevoScript.botones.slice(index + 1)],
                    })
                  }
                  className="remove-button"
                >
                  x
                </button>
                <br />
                <input
                  onChange={(e) =>
                    setNuevoScript({
                      ...nuevoScript,
                      botones: [...nuevoScript.botones.slice(0, index), e.target.value, ...nuevoScript.botones.slice(index + 1)],
                    })
                  }
                  value={nuevoScript.botones[index]}
                ></input>
              </div>
            );
          })}
        <button
          onClick={() =>
            nuevoScript.botones
              ? setNuevoScript({ ...nuevoScript, botones: [...nuevoScript.botones, ''] })
              : setNuevoScript({ ...nuevoScript, botones: [''] })
          }
          className="add-button"
          style={{ width: 80, height: 80, marginTop: 10 }}
        >
          +
        </button>
      </div>
    </div>
  );
}

//#endregion

//#region Seccion para la asignacion de funciones

function Functions({ nuevoScript, setNuevoScript, functionesChatbot }) {
  const funcionDefault = { nombreFuncion: '', guardarEn: '', parametros: [] };

  console.log('Dentro de funciones tenemos a:', nuevoScript);
  return (
    <div>
      <br />
      <hr />

      {!nuevoScript.ejecutaFuncion && (
        <div>
          <b>Funciones que Ejecuta </b>
        </div>
      )}
      <div>
        {nuevoScript.ejecutaFuncion &&
          nuevoScript.ejecutaFuncion.map((funcion, index) => {
            return (
              <div key={index} style={{ margin: 10, textAlign: 'center' }}>
                <hr style={{ borderWidth: '2px' }} />
                <h2>Función número {index + 1}</h2>
                <h3>- {funcion.nombreFuncion} -</h3>
                <button
                  onClick={() => {
                    const temp = { ...nuevoScript };

                    if (temp.ejecutaFuncion.length === 1) {
                      delete temp.ejecutaFuncion;
                    } else {
                      temp.ejecutaFuncion = [...temp.ejecutaFuncion.slice(0, index), ...temp.ejecutaFuncion.slice(index + 1)];
                    }

                    setNuevoScript(temp);
                  }}
                  className="remove-button"
                  style={{ marginLeft: '0px' }}
                >
                  x
                </button>
                <br />
                <small>Nombre de la función</small>
                <br />
                {/* <input
									onChange={(e) =>
										setNuevoScript({
											...nuevoScript,
											ejecutaFuncion: [
												...nuevoScript.ejecutaFuncion.slice(0, index),
												{ ...nuevoScript.ejecutaFuncion[index], nombreFuncion: e.target.value },
												...nuevoScript.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={nuevoScript.ejecutaFuncion[index].nombreFuncion}></input> */}
                <select
                  onChange={(e) =>
                    setNuevoScript({
                      ...nuevoScript,
                      ejecutaFuncion: [
                        ...nuevoScript.ejecutaFuncion.slice(0, index),
                        { ...nuevoScript.ejecutaFuncion[index], nombreFuncion: e.target.value },
                        ...nuevoScript.ejecutaFuncion.slice(index + 1),
                      ],
                    })
                  }
                  value={nuevoScript.ejecutaFuncion[index].nombreFuncion}
                >
                  <option key="" value="">
                    Selecciona un archivo
                  </option>
                  {functionesChatbot.map((funcion) => (
                    <option key={funcion} value={funcion}>
                      {funcion}
                    </option>
                  ))}
                </select>
                <br />
                <small>Parámetros</small>
                <br />
                {funcion.parametros &&
                  funcion.parametros.map((parametro, index2) => {
                    return (
                      <div key={index2}>
                        <input
                          onChange={(e) =>
                            setNuevoScript({
                              ...nuevoScript,
                              ejecutaFuncion: [
                                ...nuevoScript.ejecutaFuncion.slice(0, index),
                                {
                                  ...nuevoScript.ejecutaFuncion[index],
                                  parametros: [
                                    ...nuevoScript.ejecutaFuncion[index].parametros.slice(0, index2),
                                    e.target.value,
                                    ...nuevoScript.ejecutaFuncion[index].parametros.slice(index2 + 1),
                                  ],
                                },
                                ...nuevoScript.ejecutaFuncion.slice(index + 1),
                              ],
                            })
                          }
                          value={nuevoScript.ejecutaFuncion[index].parametros[index2]}
                        />

                        <button
                          onClick={() =>
                            setNuevoScript({
                              ...nuevoScript,
                              ejecutaFuncion: [
                                ...nuevoScript.ejecutaFuncion.slice(0, index),
                                {
                                  ...nuevoScript.ejecutaFuncion[index],
                                  parametros: [
                                    ...nuevoScript.ejecutaFuncion[index].parametros.slice(0, index2),
                                    toggle_variable(nuevoScript.ejecutaFuncion[index].parametros[index2]),
                                    ...nuevoScript.ejecutaFuncion[index].parametros.slice(index2 + 1),
                                  ],
                                },
                                ...nuevoScript.ejecutaFuncion.slice(index + 1),
                              ],
                            })
                          }
                          className="toggle-button"
                          style={{ wordWrap: 'unset' }}
                        >
                          {parametro[0] === '&' ? 'Convertir a constante' : 'Convertir a variable'}
                        </button>

                        <button
                          onClick={() => {
                            const aristaTemp = { ...nuevoScript };
                            const funcion = aristaTemp.ejecutaFuncion[index];

                            funcion.parametros = [...funcion.parametros.slice(0, index2), ...funcion.parametros.slice(index2 + 1)];

                            aristaTemp.ejecutaFuncion[index] = funcion;

                            setNuevoScript(aristaTemp);
                          }}
                          className="remove-button"
                          style={{ marginLeft: '5px' }}
                        >
                          x
                        </button>
                      </div>
                    );
                  })}
                <button
                  onClick={() =>
                    setNuevoScript({
                      ...nuevoScript,
                      ejecutaFuncion: [
                        ...nuevoScript.ejecutaFuncion.slice(0, index),
                        {
                          ...nuevoScript.ejecutaFuncion[index],
                          parametros: nuevoScript.ejecutaFuncion[index].parametros
                            ? [...nuevoScript.ejecutaFuncion[index].parametros, '']
                            : [''],
                        },
                        ...nuevoScript.ejecutaFuncion.slice(index + 1),
                      ],
                    })
                  }
                  className="add-button rectangle"
                >
                  +
                </button>
              </div>
            );
          })}
        <button
          onClick={() =>
            nuevoScript.ejecutaFuncion
              ? setNuevoScript({
                  ...nuevoScript,
                  ejecutaFuncion: [...nuevoScript.ejecutaFuncion, funcionDefault],
                })
              : setNuevoScript({ ...nuevoScript, ejecutaFuncion: [funcionDefault] })
          }
          className="add-button square"
        >
          +
        </button>
      </div>
    </div>
  );
}

//#endregion

//#region Seccion de los botones para guardado

function SaveDelete({ nuevoScript, refreshData, setNotification, flagFunctions }) {
  const history = useHistory();

  function saveScript() {
    putScriptNoFlujo(nuevoScript)
      .then(() => {
        setNotification('mScript editado correctamente!');
        refreshData();
        history.push('/scripts');
      })
      .catch(() => {
        setNotification('mNo ha sido posible editar el script!');
        refreshData();
        history.push('/scripts');
      });
  }

  // Las validaciones deben de regresar true cuando algo no esta validado
  // Se valida que se haya escogido un nodo de destino
  const nodoDestinoValidation = nuevoScript.nodoDestino === 0;

  // Se valida que se haya definido al menos un script de mensaje
  const scriptValidation = nuevoScript.scripts.length === 0;

  // Se valida que se hayan definido los scripts correctamente
  const scriptEmptyValidation = !nuevoScript.scripts.every((script) => script.valor !== '');

  // Se valida que no haya funciones con nombres vacios
  const functionsValidation = nuevoScript.ejecutaFuncion
    ? !nuevoScript.ejecutaFuncion.every((funcion) => funcion.nombreFuncion !== '')
    : false;

  return (
    <div>
      <div className="form-actions" align="right">
        <button className="form-button secondary-button" onClick={() => history.push('/scripts')}>
          {/* <button disabled={flagFunctions} className="form-button secondary-button" onClick={() => history.push('/scripts')}> */}
          Cancelar
        </button>
        <button
          disabled={nodoDestinoValidation || scriptValidation || functionsValidation || scriptEmptyValidation}
          onClick={saveScript}
          className="form-button primary-button"
        >
          Guardar
        </button>
      </div>

      {/* {flagFunctions && (
        <div align="right">
          <span style={{ fontSize: '12px', color: 'red' }}>
            * Se ha detectado un cambio en las funciones, es forzoso guardar el script *
          </span>
        </div>
      )} */}

      {nodoDestinoValidation && (
        <div align="right">
          <span style={{ fontSize: '12px', color: 'red' }}>* Se debe especificar el nodo destino *</span>
        </div>
      )}

      {scriptValidation && (
        <div align="right">
          <span style={{ fontSize: '12px', color: 'red' }}>* Debe existir al menos un script *</span>
        </div>
      )}

      {scriptEmptyValidation && (
        <div align="right">
          <span style={{ fontSize: '12px', color: 'red' }}>* Existen scripts que no se encuentran definidos *</span>
        </div>
      )}

      {functionsValidation && (
        <div align="right">
          <span style={{ fontSize: '12px', color: 'red' }}>* Existen funciones sin nombre *</span>
        </div>
      )}
    </div>
  );
}

//#endregion
